import { RequireAtLeastOne } from 'type-fest';
import { HttpContextToken, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { extractHttpContextAndValue, WithContextOptions } from './http-context.model';

type HttpErrorPopupFactory = (error?: HttpErrorResponse) => boolean | HttpErrorPopupConfig;
export type HttpErrorPopupConfig = RequireAtLeastOne<{
  title?: string;
  debug?: boolean;
  message?: string | ((error?: HttpErrorResponse) => string);
  disableClose?: boolean;
}>;

export type HttpErrorPopup = HttpErrorPopupConfig | boolean | HttpErrorPopupFactory;

const HAS_ERROR_POPUP = new HttpContextToken<HttpErrorPopup>(() => true);

export function withErrorPopup(options?: WithContextOptions<HttpErrorPopupConfig> | boolean | HttpErrorPopupFactory) {
  const { context, value } = extractHttpContextAndValue(options);
  return context.set(HAS_ERROR_POPUP, value);
}

export function hasErrorPopup(req: HttpRequest<unknown>) {
  return req.context.get(HAS_ERROR_POPUP);
}
